namespace TR {
    export class Friend {
        Name: String = '';
        Email: String = '';
    }

    export interface DiscountsService {
        referFriends(friends: Friend[]);
        getDiscountCodeForUser(): Promise<string>;
        validate(): Promise<void>;
    }
}
